<script setup lang="ts">
interface Props {
    submitButtonString: string;
    options?: {
        submitButtonDirection: "left" | "right";
    };
}
const props = withDefaults(defineProps<Props>(), {
    options: () => ({
        submitButtonDirection: "left",
    }),
});

const emit = defineEmits(["submit"]);
</script>

<template>
    <AppDialog v-on="props">
        <template #content>
            <slot name="content"></slot>
        </template>
        <template #action="{ close }" v-if="options.submitButtonDirection == 'left'">
            <AppButton class="button" @click="emit('submit')">{{ submitButtonString }}</AppButton>
            <AppButton class="button" @click="close" color="gray">취소</AppButton>
        </template>
        <template #action="{ close }" v-if="options.submitButtonDirection == 'right'">
            <AppButton class="button" @click="close" color="gray">취소</AppButton>
            <AppButton class="button" @click="emit('submit')">{{ submitButtonString }}</AppButton>
        </template>
    </AppDialog>
</template>

<style lang="scss" scoped>
.button {
    min-width: 120px;
}
</style>
